import React from "react";
import { Route, Routes } from "react-router-dom";
import UserHome from "./Home";
import Travel from "./Travel";
import Approvals from "./Approvals";
import Travellers from "../Common/Travellers";
import Receipts from "./Expense/Receipts";
import Bookings from "./Travel/Bookings";
import ViewTraveller from "../Common/Travellers/Users/ViewTraveller";

function EmployeeRoutes() {
	return (
		<Routes>
			<Route path="/bookings" element={<Bookings />} />
			<Route path="/travellers/:userId" element={<ViewTraveller />} />
			<Route path="/travellers" element={<Travellers />} />
			<Route path="/approvals/*" element={<Approvals />} />
			<Route path="/expense/*" element={<Receipts />} />
			<Route path="/travel/*" element={<Travel />} />
			<Route path="/home" element={<UserHome />} />
			<Route path="/" element={<UserHome />} />
		</Routes>
	);
}

export default EmployeeRoutes;
